import { Box, Image, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import Lion from '@/assets/images/lion.png'

export default function ShareLion() {
  const t = useTranslations('chart')
  return (
    <Box>
      <Text variant={'body'} mb={12}>
        {t('priceWithLion')}
      </Text>
      <Image src={Lion.src} w={160} />
    </Box>
  )
}
